export default {
  TYPE: 'binary',
  CELLTEXT: true,
  CELLDATES: false,
  RAW: false,
  DATENF: 'dd/mm/yyyy;@'
};
